import { logger } from "c7-logger";

export const getJWTPayload = function (payload: string): string {
  if (!payload) {
    return "";
  }

  const parts = payload.split(".");

  if (parts.length !== 3) {
    logger.error("String does not follow JWT structure");
    return "";
  }
  // payload
  return atob(parts[1]);
};

export const getJWTPayloadJSON = function <T>(payload: string): T {
  const unprocessedPayload = getJWTPayload(payload);
  try {
    return JSON.parse(unprocessedPayload) as T;
  } catch (e) {
    return {} as T;
  }
};

export type CheckoutIntentPayload = {
  ksi: string;
  Role: Array<string>;
  mor: string;
  od: string;
  iss: string;
  mid: string;
  oid: string;
  exp: number;
  msr: string;
  spi: string;
  iat: number;
  cid: string;
};
